<template>
  <v-dialog max-width="600px" v-model="inDialog" persistent>
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
                $t(formCreateName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-layout wrap>
                <v-flex xs10 sm10 md10 lg10 xl10 style="padding: 10px">
              <v-text-field
                  :type="showPassword ? 'text' : 'password'"
                  :label="$t('lang.school.oldPassword')"
                  v-model.trim="item.oldPassword"
                  name="oldPassword"
                  v-validate="'required'"
                  maxLength="500"
                  :error-messages="errors.first('oldPassword')"
                  :data-vv-as="$t('lang.school.oldPassword')"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs1 sm1 md1 lg1 xl1 style="padding: 10px">
              <v-btn icon @click="showPassword = !showPassword">
                <v-icon>{{ showPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs10 sm10 md10 lg10 xl10 style="padding: 10px">
              <v-text-field
                  :type="showPassword ? 'text' : 'password'"
                  :label="$t('lang.school.password')"
                  v-model.trim="item.password"
                  name="password"
                  v-validate="'required|min:8'"
                  maxLength="500"
                  :error-messages="errors.first('password')"
                  :data-vv-as="$t('lang.school.password')"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs1 sm1 md1 lg1 xl1 style="padding: 10px">
              <v-btn icon @click="showPassword = !showPassword">
                <v-icon>{{ showPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

          <v-layout wrap>
            <v-flex xs10 sm10 md10 lg10 xl10 style="padding: 10px">
              <v-text-field
                  :type="showPassword ? 'text' : 'password'"
                  :label="$t('lang.school.confirmPassword')"
                  v-model.trim="item.confirmPassword"
                  name="confirmPassword"
                  v-validate="'required'"
                  maxLength="500"
                  :error-messages="errors.first('confirmPassword')"
                  :data-vv-as="$t('lang.school.confirmPassword')"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs1 sm1 md1 lg1 xl1 style="padding: 10px">
              <v-btn icon @click="showPassword = !showPassword">
                <v-icon>{{ showPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
      <div style="text-align: right">
        <v-btn color="primary" @click="onSave">
          <v-icon dark left>save</v-icon>
          {{ $t("lang.common.save") }}
        </v-btn>
        <v-btn color="error" @click="onCancel">
          <v-icon dark left>cancel</v-icon>
          {{ $t("lang.common.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {message} from "../../../services";
import axios from "axios";
import {areaContants} from "@/constants";
import moment from "moment/moment";

export default {
  name: "school-create-form",
  components: {message, axios},
  props: {
    propsItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    cDialog: {
      type: Boolean,
      default: false,
    },
    formCreateName: {
      type: String,
      default: '',
    },


  },
  data: () => {
    return {
      areaStatus: areaContants.areaStatus,
      item: {
        className: "",
        ageId: ""
      },
      inDialog: false,
      showPassword: false,
      ages: {
        type: Array,
        default: () => {
          return []
        }
      },
      levelStarts: {
        type: Array,
        default: () => {
          return []
        }
      },
    };
  },
  watch: {
    propsItem: {
      handler(value) {
        if (value !== null) {
          this.item =  Object.assign({}, value);
        } else {
          this.resetFrom();
        }
      },
      deep: true,
    },
    cDialog(value) {
      this.inDialog = value;
    },
    inDialog(value) {
      if (!value) {
        this.$emit("closeCreateDialog", "");
      }
    },
  },
  methods: {
    resetFrom: function () {
      this.item = Object.assign({}, {"isActive": 1});
    },
    onCancel: function () {
      this.$emit("closeCreateDialog", "");
    },
    onSave: function () {
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }
        if (this.item.password !== this.item.confirmPassword) {
          message.error(this.$t("lang.school.password_not_match"));
          return;
        }
        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/schoolAccount/updatePassword",
                this.item
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.resetFrom();
                    this.onCancel();
                  } else {

                    let msg = data.description;
                    message.error(this.$t(msg));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },

  },
  created() {

  },
};
</script>
